const DELIVERY_LIKE = ['DeliveryFulfillmentMethod', 'ShippingFulfillmentMethod', 'UberDirectFulfillmentMethod']

export const isDeliveryLikeType = (type) => DELIVERY_LIKE.includes(type)
export const isUberDirectType = (type) => type === 'UberDirectFulfillmentMethod'
export const isPickupType = (type) => type === 'PickupFulfillmentMethod'

export const fulfillmentTitleFor = (type) => {
  if (type === null || type === undefined) return 'Fulfillment'
  if (type === 'PickupFulfillmentMethod') return 'Pickup'
  if (type === 'ShippingFulfillmentMethod') return 'Shipping'
  return 'Delivery'
}
